export const RouteType = {
    ipv4: 'IP_V4',
    ipv6: 'IP_V6',
    domain: 'DOMAIN',
} as const;
